import 'datatables.net-buttons/js/buttons.html5.min';
import 'datatables.net-buttons/js/buttons.print.min';
import 'datatables.net-buttons/js/dataTables.buttons.min';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake.min';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import '../ui-js/buttons.aurion';
import '../ui-js/dataTables.aurion';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.JSZip = jszip;

const handleKeyboardEvent = (event) => {
    // enter key is a click except for links
    if ((event.key === 'Enter') && (event.target.localName !== 'a')) {
        handleClickEvent(event);
    }
};

function handleClickEvent(event) {
    let node = event.target;

    if (['A', 'TH'].includes(node.nodeName)) return;

    // find the row
    if (node.nodeName !== 'TR') {
        while ((node = node.parentNode)) {
            if (node.nodeName === 'TR') break;
        }
    }

    if (!node) {
        return;
    }

    const allowDetail = node.getAttribute('data-allowdetail');
    let url;

    if (allowDetail && !allowDetail.match(/false/i)) {
        const dataUrl = node.getAttribute('data-url');
        if (dataUrl) {
            url = dataUrl;
        } else {
            url = `${node.parentNode.parentNode.getAttribute('data-url')}${node.id}/edit`;
        }
    }

    if (url) {
        url = util.urlBase() + url;
        if (!util.openInNewWindowIf(event, url)) window.location = url;
    }
}

const selectAllCheckboxRows = (table) => (event) => {
    const checkboxes = Array.from(table.getElementsByClassName('select-row-checkbox'));
    const { checked } = event.target;
    const checkboxEvent = new CustomEvent('table-select-all-click', {
        detail: {
            target: event.target,
        },
    });
    checkboxes.forEach((x) => {
        x.checked = checked;
    });
    table.dispatchEvent(checkboxEvent);
};

const bindRowCheckboxHandlers = (table) => {
    const selectAll = table.querySelector('.select-all-rows');
    const checkboxes = Array.from(table.getElementsByClassName('select-row-checkbox'));

    const checkboxEvent = new CustomEvent('table-checkbox-click', {
        detail: {
            table,
        },
    });

    table.addEventListener('click', (e) => {
        if (e.target
            && e.target.type === 'checkbox'
            && e.target.classList.contains('select-row-checkbox')) {
            table.dispatchEvent(checkboxEvent);
            selectAll.checked = checkboxes.every((c) => c.checked) && e.target.checked;
        }
    });
};

const bindCheckboxHandlers = (table) => {
    const selectAll = table.querySelector('.select-all-rows');
    if (selectAll) {
        selectAll.addEventListener('click', selectAllCheckboxRows(table));
        bindRowCheckboxHandlers(table);
    }
};

const addCheckboxes = (jsonVar) => {
    const i = jsonVar.columns.findIndex((x) => x.name === 'aurion_id');
    const vi = jsonVar.columns.findIndex((x) => x.name === 'aurion_version');
    const ti = jsonVar.columns.findIndex((x) => x.name === 'aurion_table_name');
    const sci = jsonVar.columns.findIndex((x) => x.name === 'aurion_show_checkbox');

    jsonVar.columns.unshift({
        name: 'select-row',
        title: '<input type="checkbox" name="select-all-rows" class="select-all-rows" aria-label="Select all rows">',
        orderable: false,
        targets: 0,
        width: '1%',
    });

    jsonVar.data = jsonVar.data.map((x) => {
        let d = '';
        // show checkbox when no show checkbox specified or it is specified and true
        if (sci === -1 || x[sci]) {
            d = `<input name="select-row-checkbox" class="select-row-checkbox" type="checkbox" value="${x[i]}" data-version="${x[vi]}" data-table="${x[ti]}" aria-label="Select row">`;
        }
        x.unshift(d);
        return x;
    });

    return jsonVar;
};

// since some tables use raw data the tab index must be added here to each field for keyboard accessibility
const setTableFieldTabIndex = (target) => {
    [...target.getElementsByTagName('tr')].forEach((tr) => {
        tr.setAttribute('tabindex', 0);
    });
};

function init() {
    const datatables = $('table.table-datatables');
    datatables.each(function () {
        const $this = $(this);
        const hasCheckboxes = $this.is('[data-has-checkboxes]');
        let datatablesOpts = {
            buttons: [],
            deferRender:  true,
            info: false,
            language: {
                buttons: {
                    pageLength: {
                        _: 'Show %d entries',
                    },
                },
                paginate: {
                    first: '«', // This is the link to the first page
                    last: '»', // This is the link to the last page
                    next: '›', // This is the link to the next page
                    previous: '‹', // This is the link to the previous page
                },
                search: 'Filter:',
            },
            order: [],
            ordering: false,
            paging: false,
            searching: false,
        };
        if (hasCheckboxes) {
            datatablesOpts = $.extend({}, datatablesOpts, {
                drawCallback: () => {
                    $('.select-row-checkbox, .select-all-rows', $this).prop('checked', false);
                },
            });
        }
        // if there is a json variable configured then consume the data from there instead of
        // parsing the HTML structure of the table
        if ($this.is('[data-json-variable]') && $($this.attr('data-json-variable'))) {
            const jsonEl = document.getElementById($this.attr('data-json-variable'));
            let jsonVar = JSON.parse(jsonEl.textContent || jsonEl.innerText);

            const rowValues = {
                hasDetailView: $this.is('[data-has-detail-view]'),
            };
            // find the interesting hidden columns key
            jsonVar.columns.forEach((v, k) => {
                if (v.name === 'aurion_id') {
                    rowValues.id = k;
                    // hack to fix the checkbox offsetting the row id
                    if (hasCheckboxes) {
                        rowValues.id = k + 1;
                    }
                } else if (v.name === 'aurion_url') {
                    rowValues.url = k;
                }
            });

            if (hasCheckboxes) {
                jsonVar = addCheckboxes(jsonVar);
            }

            datatablesOpts = $.extend({}, jsonVar, {
                columnDefs: [{
                    targets: '_all',
                    createdCell: (cell, cellData, rowData, rowIndex, colIndex) => {
                        $(cell).attr('data-th', jsonVar.columns[colIndex].title);
                    },
                }],
                initComplete: (settings) => {
                    $(settings.nTHead).addClass('table-dark');
                    if (hasCheckboxes) {
                        bindCheckboxHandlers(this);
                    }
                },
                rowCallback: (row, data) => {
                    const $row = $(row);
                    if ('id' in rowValues && data[rowValues.id]) {
                        $row.attr('id', data[rowValues.id]);
                    }
                    if ('url' in rowValues && data[rowValues.url]) {
                        $row.attr('data-url', data[rowValues.url]);
                    }
                    if (rowValues.hasDetailView) {
                        $row.attr('data-allowDetail', 'true');
                        $row.addClass('table-clickable-row');
                    }
                },
            }, datatablesOpts);
        }

        if (this.hasAttribute('data-server-side')) {
            // all but the initial draw should use AJAX requests
            datatablesOpts.columnDefs = [{
                createdCell(cell, cellData, rowData, rowIndex, colIndex) {
                    if (rowData.columns) {
                        // this is AJAX data so we need to mimic a normal cell
                        const column = rowData.columns[colIndex];
                        cell.classList.add(column['data-type']);
                        cell.setAttribute('data-th', column['data-th']);

                        if (column['data-type'] === 'date' && column.value) {
                            // we need to provide a DataTables-friendly date for ordering
                            cell.setAttribute(
                                'data-order',
                                window.moment(column.value, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                            );
                        }
                    }
                },
                targets: '_all',
            }];
        }

        if (this.hasAttribute('data-paging')) {
            datatablesOpts.buttons.push({
                extend: 'pageLength',
                fade: 0,
            });
        }

        if (this.hasAttribute('data-download-all') && !window.device.mobile()) {
            const downloadType = this.getAttribute('data-download-all');
            let apiUrl;
            let fileBaseUrl;

            if (downloadType === 'past-employee-pay-summaries') {
                apiUrl = `${util.urlBase()}past-employees/api/download-all-pay-summaries`;
                fileBaseUrl = `${util.urlBase()}past-employees/file/39/`;
            }

            if (apiUrl) {
                datatablesOpts.buttons.push({
                    text: 'Download All',
                    className: 'dataTables_button',
                    action(e) {
                        if (e) e.preventDefault();

                        window.loading.load();

                        ajax({
                            url:          apiUrl,
                            method:       'POST',
                            documentType: 'json',
                            success(response) {
                                window.location = `${fileBaseUrl}${response.fileUrl}`;
                                return { notify: { title: 'Success' } };
                            },
                            callback() {
                                window.loading.remove();
                            },
                        });
                    },
                });
            }
        }

        if (this.hasAttribute('data-full-screen') && !window.device.mobile()) {
            const fullScreenClass = 'dataTables_full-screen';
            datatablesOpts.buttons.push({
                text: 'Full Screen',
                className: 'dataTables_button',
                action(e) {
                    const btn = e.currentTarget;
                    const btnText = btn.getElementsByTagName('span')[0];
                    let section = btn.parentNode;
                    while (section && section.nodeName !== 'SECTION') {
                        section = section.parentNode;
                    }
                    if (!section) return;

                    if (section.classList.contains(fullScreenClass)) {
                        section.classList.remove(fullScreenClass);
                        section.style.height = '';
                        btnText.textContent = 'Full Screen';
                        const iconEl = btn.getElementsByTagName('i')[0];
                        if (iconEl) btn.removeChild(iconEl);
                        section.scrollIntoView();
                    } else {
                        section.classList.add(fullScreenClass);
                        section.style.height = `${document.body.scrollHeight}px`;
                        btnText.textContent = ' Done';
                        const iconEl = document.createElement('i');
                        iconEl.classList.add('iconic');
                        iconEl.classList.add('iconic-carriage-return');
                        btn.insertAdjacentElement('afterbegin', iconEl);
                        window.scrollTo(0, 0);
                    }
                },
            });
        }

        if (this.hasAttribute('data-export')) {
            const exportOptions = { columns: ':visible:not(.rowselector)' };
            const getHeading = (element) => {
                if (/H[1-6]/.test(element.tagName)) return element.textContent.trim();

                if (element.tagName === 'HEADER' || element.className === 'header') {
                    const heading = Array.from(element.children)
                        .find((child) => /H[1-6]/.test(child.tagName));
                    if (heading) return heading.textContent.trim();
                }
            };
            const findHeading = () => {
                let parent = this;

                while ((parent = parent.parentElement)) {
                    let heading = getHeading(parent);
                    if (heading) return heading;

                    let sibling = parent;

                    while ((sibling = sibling.previousElementSibling)) {
                        heading = getHeading(sibling);
                        if (heading) return heading;
                    }
                }

                return document.title;
            };

            datatablesOpts.buttons.push({
                autoClose: true,
                buttons: [
                    {
                        exportOptions,
                        extend: 'copy',
                        title: findHeading,
                    },
                    {
                        exportOptions,
                        extend: 'csv',
                        filename: findHeading,
                    },
                    {
                        exportOptions,
                        extend: 'excel',
                        filename: findHeading,
                        title: findHeading,
                    },
                    {
                        exportOptions,
                        extend: 'pdf',
                        filename: findHeading,
                        title: findHeading,
                    },
                    {
                        exportOptions,
                        extend: 'print',
                        title: findHeading,
                    },
                ],
                extend: 'collection',
                fade: 0,
                text: 'Export',
            });
        }

        $this.DataTable(datatablesOpts);
    });

    Array.from(document.getElementsByClassName('table')).forEach((node) => {
        if (!node.hasAttribute('data-raw-list')) {
            node.addEventListener('click', handleClickEvent);
            node.addEventListener('keyup', handleKeyboardEvent);
        }
    });

    finalise();
    datatables.on('draw.dt', finalise);
    initialiseClickableUrlCells();
}

function finalise(event) {
    const target = event ? window.util.parent(event.target, 'div.dataTables_wrapper') : document;
    $('ul.pagination', target).addClass('pagination-sm');
    $('.dataTables_info', target).wrapInner(function () {
        return this.childElementCount ? '' : '<small></small>';
    });
    Array.from(target.querySelectorAll('input.form-control.form-control-xs')).forEach((filter) => {
        filter.name = 'datatables-filter';
    });
    setTableFieldTabIndex(target);
}

function initialiseClickableUrlCells() {
    Array.from(document.querySelectorAll('.table-clickable-url-cell')).forEach((node) => {
        if (node.hasAttribute('data-href')) {
            node.addEventListener('click', (event) => {
                const { target } = event;
                if (target.hasAttribute('data-href')) {
                    window.document.location = target.getAttribute('data-href');
                }
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', init);
const tablelist = { init };
window.tablelist = tablelist;
export default tablelist;
